import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './shared/auth/AuthContext';
import { FontProvider } from './shared/contexts/FontContext';
import { AppRoutes } from './routes';
import ErrorBoundary from './shared/components/ErrorBoundary';
import ScrollToTop from './shared/components/ScrollToTop';
import { usePageView } from './shared/hooks/usePageView';
import AnalyticsConsentBanner from './shared/components/AnalyticsConsentBanner';
import './App.css';

function AppContent() {
  // ページビューを自動的に記録（同意済みの場合のみ送信）
  usePageView();

  return (
    <div className="App">
      <AnalyticsConsentBanner />
      <AppRoutes />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <FontProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppContent />
          </BrowserRouter>
        </AuthProvider>
      </FontProvider>
    </ErrorBoundary>
  );
}

export default App;